"use client";

import { NewRelicMemoryTracker } from "@/components/monitoring/NewRelicMemoryTracker";
import {
  FeatureFlagProvider,
  FiatPricingProvider,
  PassportProvider,
  QueryProvider,
} from "@/context";
import { AnalyticsProvider } from "@/context/AnalyticsProvider";
import { BrazeProvider } from "@/context/BrazeProvider";
import { PreferencesProvider } from "@/context/PreferencesProvider";
import theme from "@/styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <AnalyticsProvider>
      <PassportProvider>
        <FeatureFlagProvider>
          <QueryProvider>
            <PreferencesProvider>
              <FiatPricingProvider>
                <BrazeProvider>
                  <ThemeProvider theme={theme}>
                    {/* Memory & performance tracking - sends metrics to New Relic every 60s */}
                    <NewRelicMemoryTracker intervalMs={60000} />
                    {children}
                  </ThemeProvider>
                </BrazeProvider>
              </FiatPricingProvider>
            </PreferencesProvider>
          </QueryProvider>
        </FeatureFlagProvider>
      </PassportProvider>
    </AnalyticsProvider>
  );
}
